<template>
  <el-card shadow="never">
    <!-- <el-page-header
      @back="() => $router.go(-1)"
      content="Dashboard"
    /> -->
    <template slot="header">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ name: dashboardPath }">Dashboard</el-breadcrumb-item>
      </el-breadcrumb>
    </template>
    <div class="hero-wrapper">
      <FacilityOccupancy :facility="facility" />
      <FacilityYield :facility="facility" />
      <FacilityRevenue :facility="facility" />
      <FacilityExpInsurance :facility="facility" />
    </div>
    <br/>
    <FacilityUpcomingScheduledUnits :facility="facility"/>
    <br/>
    <div class="dashboard-wrapper">
      <FacilityOpenUnits :facility="facility" />
      <FacilityCollections :facility="facility" dashboard/>
    </div>
  </el-card>
</template>

<script>
import FacilityOccupancy from './FacilityOccupancy.vue';
import FacilityYield from './FacilityYield.vue'
import FacilityRevenue from './FacilityRevenue.vue';
import FacilityExpInsurance from './FacilityExpInsurance.vue';
import FacilityUpcomingScheduledUnits from './FacilityUpcomingScheduledUnits.vue';
import FacilityOpenUnits from './FacilityOpenUnits.vue';
import FacilityCollections from './FacilityCollections.vue';
import { getFacility } from '../utils/commonApi';

export default {
  name: 'DashboardPage',
  props: {
    facility: { type: String, required: true },
  },
  async mounted() {
    await this.getFacility();
  },
  watch: {
    async facility() {
      await this.getFacility();
    },
  },
  computed: {
    dashboardPath() {
      return this.$root.state.facility ? 'Facility Dashboard' : 'Dashboard';
    },
    hasAccess() {
      const roles = this.$keycloak.tokenParsed.realm_access.roles;
      if (roles.includes('level_1')) {
        return true;
      }
      return false;
    },
  },
  components: {
    FacilityOccupancy,
    FacilityYield,
    FacilityRevenue,
    FacilityExpInsurance,
    FacilityUpcomingScheduledUnits,
    FacilityOpenUnits,
    FacilityCollections,
  },
  methods: {
    async getFacility() {
      if (this.hasAccess) {
        const data = await getFacility(this.facility, { token: this.$keycloak.token });
        if (!data.pricing || !data.officePricing || !data.parkingPricing) {
          this.$message({
            type: 'warning',
            title: 'Warning',
            message: 'Facility is missing with pricing values.',
          });
        }
        return data;
      }
      return false;
    },
  },
};
</script>

<style scoped>
.hero-wrapper, .dashboard-wrapper {
  display: grid;
  gap: 1rem;
}

@media (min-width: 768px) {
  .hero-wrapper {
    grid: 1fr / 1fr 1fr 1fr 1fr;
  }

  .dashboard-wrapper {
    grid: 1fr / 1fr 1fr;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardPage.vue